import { supabase } from '../client/supabaseClient';
import { User } from '@supabase/supabase-js';

/**
 * Checks if a user is a teacher by calling the is_teacher RPC function
 * @param user The user to check
 * @returns True if the user is a teacher, false otherwise
 */
export const checkIfUserIsTeacher = async (user: User | null): Promise<boolean> => {
  if (!user) {
    console.log('Teacher check: No user provided');
    return false;
  }
  
  console.log('Checking teacher status for user ID using RPC:', user.id);
  
  try {
    // Call the is_teacher() RPC function
    const { data, error } = await supabase.schema('api').rpc('is_teacher');
    
    console.log('Teacher check RPC result:', { data, error });
    
    if (error) {
      console.error('Error checking teacher status with RPC:', error);
      return false;
    }
    
    // The function returns a boolean directly
    return data || false;
  } catch (error) {
    console.error('Error in checkIfUserIsTeacher RPC call:', error);
    return false;
  }
};

/**
 * SQL to create the is_teacher function in Supabase:
 * 
 * create or replace function api.is_teacher()
 * returns boolean
 * language plpgsql
 * security definer
 * as $$
 * begin
 *   return exists (
 *     select 1 from teachers where id = auth.uid()
 *   );
 * end;
 * $$;
 */
